import { APP_CUSTOM_ERROR } from "../../constants/AppVarConstants";
import { GET_ALL_JOBS, GET_APPLIED_JOBS, GET_JOB_DETAILS, GET_SHORTLISTED_JOBS, JOB_ACTION_URL } from "../api/config";
import API_MIDDLEWARE from "../api/middleware";
import { SET_APPLIED_JOBS, SET_JOB_DETAILS, SET_LISTING_JOBS, SET_SHORTLISTED_JOBS, SET_JOB_SEARCH_FILTERS, CLEAR_JOB_SEARCH_FILTERS } from "./actionTypes";
import { beginAjaxCall, endAjaxCall } from "./ajaxStatusActions";
import { refreshUserDemographics, setApplyBlocked, setErrorMessage } from "./appActions";
import {
  getDemographicsInputFromAppState,
  isDemographicsComplete,
  mergeApplyBlockedWithDemographics,
  parseApplyBlockedError,
} from "../../utils/jobApplyValidation";
import store from "../store";

export const getAppliedJobs = (payload: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_APPLIED_JOBS, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_APPLIED_JOBS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getSavedJobs = (payload: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_SHORTLISTED_JOBS, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_SHORTLISTED_JOBS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const getBrowseJobs = (payload: any): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_ALL_JOBS, "POST", { "Content-Type": "application/json" }, payload)
      .then((res) => {
        dispatch({ type: SET_LISTING_JOBS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const jobAction = (
  jobId: string,
  action: string,
  onSuccess: (res: any) => void,
  onSettled?: () => void
): any => {
  return async (dispatch: any) => {
    let demographicsInput = getDemographicsInputFromAppState(store.getState());

    if (!isDemographicsComplete(demographicsInput)) {
      await dispatch(refreshUserDemographics());
      demographicsInput = getDemographicsInputFromAppState(store.getState());
    }

    const demographicsBlocked = mergeApplyBlockedWithDemographics(null, demographicsInput);
    if (demographicsBlocked) {
      dispatch(setApplyBlocked(demographicsBlocked));
      onSettled?.();
      return;
    }

    dispatch(beginAjaxCall());
    try {
      const res = await API_MIDDLEWARE(
        `${JOB_ACTION_URL}?action=${action}&jobId=${jobId}`,
        "POST",
        { "Content-Type": "application/json" },
        {}
      );
      onSuccess(res);
      dispatch(endAjaxCall());
      onSettled?.();
    } catch (err: any) {
      let freshDemographicsInput = getDemographicsInputFromAppState(store.getState());
      if (!isDemographicsComplete(freshDemographicsInput)) {
        await dispatch(refreshUserDemographics());
        freshDemographicsInput = getDemographicsInputFromAppState(store.getState());
      }

      const blocked = mergeApplyBlockedWithDemographics(parseApplyBlockedError(err), freshDemographicsInput);
      if (blocked) {
        dispatch(setApplyBlocked(blocked));
      } else {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
      }
      dispatch(endAjaxCall());
      onSettled?.();
    }
  };
};

export const getJobDetails = (jobId: string): any => {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    API_MIDDLEWARE(GET_JOB_DETAILS(jobId), "POST", { "Content-Type": "application/json" }, {})
      .then((res) => {
        dispatch({ type: SET_JOB_DETAILS, payload: res?.result });
        dispatch(endAjaxCall());
      })
      .catch((err) => {
        dispatch(setErrorMessage(err.errorMsg ?? APP_CUSTOM_ERROR));
        dispatch(endAjaxCall());
      });
  };
};

export const setJobSearchFilters = (filters: any): any => {
  return { type: SET_JOB_SEARCH_FILTERS, payload: filters };
};

export const clearJobSearchFilters = (defaultFilters: any) => {
  return { type: CLEAR_JOB_SEARCH_FILTERS, payload: defaultFilters };
};
